import React, { useState, useRef, useEffect, useContext } from 'react';
import './style.css';
import SolvingFor from './SolvingFor/SolvingFor';
import LabAnalysisOverview from './LabAnalysisOverview/LabAnalysisOverview';
import LabAnalysisPayoff from './LabAnalysisPayoff/LabAnalysisPayoff';
import LabAnalysisDiscounts from './LabAnalysisDiscounts/LabAnalysisDiscounts';
import LabAnalysisCosts from './LabAnalysisCosts/LabAnalysisCosts';
import { WindowSizeContext } from '/src/App';

const Analysis = ({
    projectsList,
    simulatorData,
    propertyData
}) => {
    const { deviceType } = useContext(WindowSizeContext);
    const [currentSection, setCurrentSection] = useState(0);
    const sectionsContainerRef = useRef(null);
    const sections = ['overview', 'payoff', 'discounts', 'costs'];
    console.log('ANALYSIS INPUTS', projectsList, simulatorData, propertyData);

    // Track which section is currently in view
    const handleScroll = () => {
        if (sectionsContainerRef.current) {
            const sectionHeight = sectionsContainerRef.current.clientHeight;
            const scrollPosition = sectionsContainerRef.current.scrollTop;
            const currentIndex = Math.round(scrollPosition / sectionHeight);
            setCurrentSection(currentIndex);
        }
    };

    // Handle dot click navigation
    const handleDotClick = (index) => {
        if (sectionsContainerRef.current) {
            const sectionHeight = sectionsContainerRef.current.clientHeight;
            sectionsContainerRef.current.scrollTo({
                top: index * sectionHeight,
                behavior: 'smooth'
            });
        }
    };

    const colorWheel = ["#954BDB", "#53C7ED", "#EDA153", "#53EDBF", "#688C98", "#EDC453", "#5D6E69", "#C3FCFD", "#F524BF", "#86C513", "#744687", "#1231C6", "#096750", "#95B396", "#E24618", "#4390BE", "#78D8CC", "#4A6B73", "#450155", "#46E966"]

    // Iterate through the projectsList and add a color property to each project
    const projectsListWithColors = projectsList.map((project, index) => ({
        ...project,
        colorWheel: colorWheel[index % colorWheel.length]
    }));

    return (
        <div className={`what-if-machine-plan-summary-analysis-container ${deviceType}`}>
            <div className="what-if-machine-plan-summary-analysis-container-column left">
                <SolvingFor
                    projectsList={projectsListWithColors}
                    simulatorData={simulatorData}
                    propertyData={propertyData}
                    currentSection={currentSection}
                />
                {/* <p>Current section: {currentSection}</p> */}
            </div>
            <div className={`what-if-machine-plan-summary-analysis-container-column right ${deviceType}`}>
                <div
                    className={`analysis-sections-container ${deviceType}`}
                    ref={sectionsContainerRef}
                    onScroll={handleScroll}
                >
                    {sections.map((section, index) => (
                        <section key={index} className="analysis-section">
                            {/* <h2>Section {index + 1}: {section}</h2> */}
                            {/* <p>This is the {section.toLowerCase()} section content...</p> */}
                            {section === 'overview' && (
                                <LabAnalysisOverview
                                    simulatorData={simulatorData}
                                />
                            )}
                            {section === 'payoff' && (
                                <LabAnalysisPayoff
                                    simulatorData={simulatorData}
                                />
                            )}
                            {section === 'discounts' && (
                                <LabAnalysisDiscounts
                                    simulatorData={simulatorData}
                                />
                            )}
                            {section === 'costs' && (
                                <LabAnalysisCosts
                                    simulatorData={simulatorData}
                                    projectsList={projectsListWithColors}
                                />
                            )}
                        </section>
                    ))}
                </div>
                {deviceType !== 'mobile' && (
                    <div className="analysis-navigation-dots">
                        {sections.map((_, index) => (
                            <button
                                key={index}
                                className={`analysis-navigation-dot ${currentSection === index ? 'active' : ''}`}
                                onClick={() => handleDotClick(index)}
                                aria-label={`Go to section ${index + 1}`}
                            />
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
};

export default Analysis;